import React from "react";
import PropTypes from "prop-types";
import { StyledListItemIcon } from "./styled";

const ListItemIcon = ({ children }) => {
    return (
        <StyledListItemIcon>
            {children}
        </StyledListItemIcon>
    );
};

ListItemIcon.propTypes = {
    children: PropTypes.node
};

ListItemIcon.defaultProps = {
};

export default React.memo(ListItemIcon);
